function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React from 'react';
import moment from 'moment';
import { Button, ColorBatch } from 'components';
import { PARTNER_COMMISSION_STATUS, partnerCommissionStatusName, partnerCommissionStatusColorMap } from 'enums';
import { getCommissionReportPartnerDocument, getCommissionReportCreditorDocument } from 'services';
import { showApiError } from 'utils';
import { jsx as ___EmotionJSX } from "@emotion/react";

var handleViewDocument = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(reportId, type) {
    var getDocument, _yield$getDocument, _yield$getDocument2, res, err, url;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getDocument = type === 'partner' ? getCommissionReportPartnerDocument : getCommissionReportCreditorDocument;
            _context.next = 3;
            return getDocument(reportId);

          case 3:
            _yield$getDocument = _context.sent;
            _yield$getDocument2 = _slicedToArray(_yield$getDocument, 2);
            res = _yield$getDocument2[0];
            err = _yield$getDocument2[1];

            if (!err) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", showApiError(err));

          case 9:
            url = URL.createObjectURL(new File([res], 'document.pdf', {
              type: 'application/pdf'
            }));
            window.open(url, '_blank');

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleViewDocument(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export var allPastReportsColumns = function allPastReportsColumns() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isAdminOrTenant = _ref2.isAdminOrTenant,
      onAccept = _ref2.onAccept;

  return [{
    name: 'Партньор',
    render: function render(row) {
      var _row$partner;

      return ___EmotionJSX("span", null, ((_row$partner = row.partner) === null || _row$partner === void 0 ? void 0 : _row$partner.name) || '-');
    }
  }, {
    name: 'Отчетена сума',
    render: function render(row) {
      return ___EmotionJSX("span", null, (Number(row.amount) || 0).toFixed(2), " ", row.currency);
    }
  }, {
    name: 'Дата на отчет',
    render: function render(row) {
      return ___EmotionJSX("span", null, row.submitted_at ? moment(row.submitted_at).format('DD.MM.YYYY') : '-');
    }
  }, {
    name: 'Дата на приемане',
    render: function render(row) {
      return ___EmotionJSX("span", null, row.accepted_at ? moment(row.accepted_at).format('DD.MM.YYYY') : '-');
    }
  }, {
    name: 'Статус',
    render: function render(row) {
      return ___EmotionJSX(ColorBatch, {
        type: partnerCommissionStatusColorMap[row.status]
      }, partnerCommissionStatusName[row.status]);
    }
  }, {
    name: 'Документи',
    render: function render(row) {
      return ___EmotionJSX("div", {
        style: {
          display: 'flex',
          gap: '0.5em',
          flexDirection: 'column'
        }
      }, ___EmotionJSX(Button, {
        small: true,
        onClick: function onClick() {
          return handleViewDocument(row.id, 'partner');
        }
      }, "\u0420\u041A\u041E"), row.status === PARTNER_COMMISSION_STATUS.accepted && ___EmotionJSX(Button, {
        small: true,
        onClick: function onClick() {
          return handleViewDocument(row.id, 'creditor');
        }
      }, "\u041F\u041A\u041E"));
    }
  }].concat(_toConsumableArray(isAdminOrTenant ? [{
    name: 'Действия',
    render: function render(row) {
      return row.status === PARTNER_COMMISSION_STATUS.submitted ? ___EmotionJSX(Button, {
        small: true,
        type: "success",
        onClick: function onClick() {
          return onAccept(row.id);
        }
      }, "\u041F\u0440\u0438\u0435\u043C\u0438") : null;
    }
  }] : []));
};